import type { FieldValues, FormState } from 'react-hook-form';

export const errorAdapter = <T extends FieldValues>(err: FormState<T>['errors'][keyof T]) => {
  if (typeof err?.message !== 'string') return undefined;

  return {
    id: err.message,
    errors: [err.message],
  };
};
